export const androidVersionCompatibleWithMultiProtocol = '3.0.6.9';
export const iOSVersionCompatibleWithMultiProtocol = '2.1.3';
